// frontend/src/components/Modals/PDFViewerModal.jsx
import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from 'reactstrap';

function PDFViewerModal({ isOpen, toggle, pdfUrl, title }) {

  const handleDownload = () => {
    if (!pdfUrl) return;
    
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = title || 'documento.pdf';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleOpenNewTab = () => {
    if (!pdfUrl) return;
    window.open(pdfUrl, '_blank');
  };

  const handlePrint = () => {
    if (!pdfUrl) return;
    const printWindow = window.open(pdfUrl, '_blank');
    if (printWindow) {
      printWindow.onload = () => {
        printWindow.print();
      };
    }
  };

  return (
    <Modal 
      isOpen={isOpen} 
      toggle={toggle} 
      size="xl"
      style={{ maxWidth: '95vw', margin: '1rem auto' }}
      className="pdf-viewer-modal"
    >
      {/* ✅ Header Premium con gradiente corporativo MAS+ */}
      <ModalHeader 
        toggle={toggle} 
        className="bg-gradient-primary pb-3 border-0"
        style={{
          background: 'linear-gradient(135deg, #038D81 0%, #026B62 100%)',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Patrón de fondo sutil */}
        <div 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7z' fill='rgba(255,255,255,0.03)' fill-rule='evenodd'/%3E%3C/svg%3E")`,
            opacity: 0.5,
          }}
        />
        
        <div style={{ position: 'relative', zIndex: 2 }}>
          <h5 className="mb-2 text-white font-weight-bold">
            <i className="ni ni-single-copy-04 me-2"></i>
            {title || 'Documento PDF'}
          </h5>
          
          {/* Toolbar de acciones */}
          <div className="d-flex gap-2 flex-wrap">
            <Button
              color="white"
              size="sm"
              className="btn-icon shadow-sm"
              onClick={handleOpenNewTab}
              style={{ 
                color: '#038D81',
                borderColor: 'rgba(255,255,255,0.3)',
              }}
            >
              <span className="btn-inner--icon">
                <i className="ni ni-laptop"></i>
              </span>
              <span className="btn-inner--text ms-1">Abrir en Nueva Pestaña</span>
            </Button>
            
            <Button
              color="white"
              size="sm"
              className="btn-icon shadow-sm"
              onClick={handlePrint}
              style={{ 
                color: '#038D81',
                borderColor: 'rgba(255,255,255,0.3)',
              }}
            >
              <span className="btn-inner--icon">
                <i className="ni ni-single-copy-04"></i>
              </span>
              <span className="btn-inner--text ms-1">Imprimir</span>
            </Button>
            
            <Button
              color="white"
              size="sm"
              className="btn-icon shadow-sm"
              onClick={handleDownload}
              style={{ 
                color: '#038D81',
                borderColor: 'rgba(255,255,255,0.3)',
              }}
            >
              <span className="btn-inner--icon">
                <i className="ni ni-cloud-download-95"></i>
              </span>
              <span className="btn-inner--text ms-1">Descargar</span>
            </Button>
          </div>
        </div>
      </ModalHeader>
      
      {/* ✅ Body con PDF embebido */}
      <ModalBody 
        className="p-0" 
        style={{ 
          height: '85vh',
          background: '#f8fafc',
          position: 'relative',
        }}
      >
        {pdfUrl ? (
          <div style={{ width: '100%', height: '100%', position: 'relative' }}>
            {/* Contenedor del PDF con sombra elegante */}
            <div 
              style={{
                width: '100%',
                height: '100%',
                padding: '1rem',
                boxSizing: 'border-box',
              }}
            >
              <div 
                style={{
                  width: '100%',
                  height: '100%',
                  background: 'white',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
                }}
              >
                <iframe
                  src={pdfUrl}
                  style={{
                  width: '100%',
                  height: '100%',
                  border: 'none',
                }}
                title={title || 'PDF Viewer'}
                allow="fullscreen"
              />

              </div>
            </div>

            {/* Indicador de carga sutil */}
            <div 
              className="position-absolute top-50 start-50 translate-middle"
              style={{
                pointerEvents: 'none',
                opacity: 0.2,
                zIndex: -1,
              }}
            >
              <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                <span className="visually-hidden">Cargando...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="d-flex flex-column align-items-center justify-content-center h-100">
            <div 
              className="icon icon-shape bg-gradient-primary shadow-primary text-center rounded-circle mb-3"
              style={{ width: '80px', height: '80px' }}
            >
              <i className="ni ni-folder-17 text-white" style={{ fontSize: '2rem', lineHeight: '80px' }}></i>
            </div>
            <h5 className="text-dark">No hay PDF disponible</h5>
            <p className="text-sm text-muted">
              El documento no se pudo cargar o no existe.
            </p>
          </div>
        )}
      </ModalBody>

      {/* ✅ Footer informativo */}
      <div 
        className="modal-footer border-0 bg-light"
        style={{
          padding: '0.75rem 1.5rem',
          background: 'linear-gradient(to bottom, #f8fafc, #f1f5f9)',
        }}
      >
        <div className="d-flex align-items-center w-100">
          <div className="text-xs text-muted">
            <i className="ni ni-bulb-61 me-1"></i>
            <strong>Tip:</strong> Usa Ctrl+F para buscar en el documento
          </div>
          <Button
            color="secondary"
            size="sm"
            onClick={toggle}
            className="ms-auto"
          >
            <i className="ni ni-fat-remove me-1"></i>
            Cerrar
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default PDFViewerModal;
